import React from "react";
import s from "~/components/atom/specialist/name/SpecialistAtomName.module.scss";

interface Props {
  name: string;
  iconClass?: string;
}

const SpecialistAtomName: React.FC<Props> = ({ name, iconClass }) => {
  return (
    <>
      <svg
        className={iconClass ? iconClass : s.defaultIconClass}
        width="26"
        height="26"
        viewBox="0 0 26 26"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M17.3326 10.2313C17.3326 11.4351 16.8784 12.3599 16.174 12.9913C15.46 13.6312 14.4425 14.0094 13.2685 14.0094C12.0945 14.0094 11.0769 13.6312 10.3629 12.9913C9.65851 12.3599 9.2043 11.4351 9.2043 10.2313C9.2043 7.78505 11.0664 5.88105 13.2685 5.88105C15.4706 5.88105 17.3326 7.78505 17.3326 10.2313Z"
          fill="white"
          stroke="#718096"
          strokeWidth="1.6"
        />
        <path
          d="M16.417 13.3998C16.5121 13.2503 16.6161 13.1129 16.7001 13.0019C16.7108 12.9878 16.7211 12.9741 16.7311 12.9609C16.8543 12.7974 16.9478 12.6682 17.022 12.5311C17.0839 12.4165 17.1349 12.3173 17.1765 12.2217C16.8416 12.1696 16.5476 12.0921 16.2698 11.9589C15.8417 11.7535 15.5026 11.4357 15.1218 11.0788C15.1064 11.0644 15.091 11.05 15.0756 11.0355L16.417 13.3998ZM16.417 13.3998C16.2977 13.5061 16.2033 13.6048 16.1274 13.6842C16.1208 13.6911 16.1144 13.6978 16.1081 13.7044C16.0073 13.8095 15.931 13.8867 15.8231 13.9718L15.823 13.9719C15.7706 14.0132 15.7235 14.0507 15.6801 14.0852C15.4521 14.2666 15.3275 14.3657 15.0898 14.4998L16.417 13.3998ZM11.552 10.9509L11.5517 10.9511C11.2839 11.2299 10.8385 11.6506 10.3493 11.8898L10.3491 11.8899C9.97481 12.0727 9.66093 12.1512 9.35901 12.1977C9.46167 12.4597 9.60944 12.6622 9.80874 12.9352C9.91075 13.075 10.0263 13.2333 10.1561 13.4275C10.7109 14.055 11.5644 14.6881 12.3566 14.9682L11.552 10.9509ZM11.552 10.9509C12.0663 10.4152 12.6577 10.192 13.2392 10.2048M11.552 10.9509L13.2392 10.2048M12.7521 15.0722L13.2844 15.0892C13.7329 15.0669 14.0136 15.0057 14.2446 14.923C14.496 14.833 14.7203 14.7081 15.0897 14.4998L12.7521 15.0722ZM12.7521 15.0722C12.7107 15.0639 12.653 15.051 12.5874 15.0346C12.4925 15.0108 12.4084 14.9864 12.3568 14.9682L12.7521 15.0722ZM13.2392 10.2048C13.8306 10.2179 14.48 10.4779 15.0755 11.0354L13.2392 10.2048Z"
          fill="#FEFEFE"
          stroke="#718096"
          strokeWidth="1.6"
        />
        <mask id="path-3-inside-1_895_31563" fill="white">
          <path d="M8.4043 5C8.4043 4.44772 8.85201 4 9.4043 4H17.1326C17.6849 4 18.1326 4.44772 18.1326 5V8.3237H8.4043V5Z" />
        </mask>
        <path
          d="M8.4043 5C8.4043 4.44772 8.85201 4 9.4043 4H17.1326C17.6849 4 18.1326 4.44772 18.1326 5V8.3237H8.4043V5Z"
          fill="white"
          stroke="#718096"
          strokeWidth="3.2"
          mask="url(#path-3-inside-1_895_31563)"
        />
        <mask id="path-4-inside-2_895_31563" fill="white">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13.2688 18.0353L8.28373 14.8037C5.13221 16.4215 3 19.5258 3 23.0895C3 23.3963 3.0158 23.6997 3.0467 23.9991H23.4909C23.5218 23.6997 23.5376 23.3963 23.5376 23.0895C23.5376 19.598 21.4909 16.5476 18.4442 14.9039L13.2688 18.0353Z"
          />
        </mask>
        <path
          d="M8.28373 14.8037L9.15406 13.4611L8.37693 12.9574L7.55303 13.3803L8.28373 14.8037ZM13.2688 18.0353L12.3984 19.3778L13.2395 19.9231L14.097 19.4042L13.2688 18.0353ZM3.0467 23.9991L1.45515 24.1633L1.60334 25.5991H3.0467V23.9991ZM23.4909 23.9991V25.5991H24.9342L25.0824 24.1633L23.4909 23.9991ZM18.4442 14.9039L19.2039 13.4958L18.3987 13.0614L17.616 13.535L18.4442 14.9039ZM7.41339 16.1463L12.3984 19.3778L14.1391 16.6927L9.15406 13.4611L7.41339 16.1463ZM4.6 23.0895C4.6 20.1962 6.3309 17.6047 9.01442 16.2271L7.55303 13.3803C3.93353 15.2384 1.4 18.8554 1.4 23.0895H4.6ZM4.63824 23.8348C4.61297 23.5899 4.6 23.3414 4.6 23.0895H1.4C1.4 23.4513 1.41864 23.8096 1.45515 24.1633L4.63824 23.8348ZM3.0467 25.5991H23.4909V22.3991H3.0467V25.5991ZM21.9376 23.0895C21.9376 23.3414 21.9246 23.5899 21.8993 23.8348L25.0824 24.1633C25.1189 23.8096 25.1376 23.4513 25.1376 23.0895H21.9376ZM17.6846 16.3121C20.2764 17.7103 21.9376 20.2542 21.9376 23.0895H25.1376C25.1376 18.9418 22.7055 15.3848 19.2039 13.4958L17.6846 16.3121ZM14.097 19.4042L19.2725 16.2729L17.616 13.535L12.4405 16.6663L14.097 19.4042Z"
          fill="#718096"
          mask="url(#path-4-inside-2_895_31563)"
        />
        <path
          d="M19.6192 20.5647L19.6192 20.2676C19.6192 20.1133 19.468 19.9883 19.2814 19.9883L17.3898 19.9883C17.2032 19.9883 17.052 20.1133 17.052 20.2676L17.052 20.5647C17.052 20.719 17.2032 20.844 17.3898 20.844L19.2814 20.844C19.468 20.844 19.6192 20.719 19.6192 20.5647Z"
          fill="#718096"
        />
        <path
          d="M18.4866 19.1328H18.1894C18.0352 19.1328 17.9102 19.284 17.9102 19.4705V21.3622C17.9102 21.5487 18.0352 21.7 18.1894 21.7H18.4866C18.6409 21.7 18.7659 21.5487 18.7659 21.3622V19.4705C18.7659 19.284 18.6409 19.1328 18.4866 19.1328Z"
          fill="#718096"
        />
      </svg>

      <p className="">{name}</p>
    </>
  );
};

export default SpecialistAtomName;
